"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "RedisIoAdapter", {
    enumerable: true,
    get: function() {
        return RedisIoAdapter;
    }
});
const _platformsocketio = require("@nestjs/platform-socket.io");
const _redisadapter = require("@socket.io/redis-adapter");
const _ioredis = require("ioredis");
const _ioredismock = /*#__PURE__*/ _interop_require_default(require("ioredis-mock"));
const _redisHelpers = require("~/helpers/redisHelpers");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let RedisIoAdapter = class RedisIoAdapter extends _platformsocketio.IoAdapter {
    async connectToRedis() {
        let pubClient;
        const redisUrl = (0, _redisHelpers.getRedisURL)();
        if (redisUrl) {
            pubClient = new _ioredis.Redis(redisUrl);
        } else {
            pubClient = new _ioredismock.default();
        }
        const subClient = pubClient.duplicate();
        this.adapterConstructor = (0, _redisadapter.createAdapter)(pubClient, subClient);
    }
    createIOServer(port, options) {
        const server = super.createIOServer(port, options);
        server.adapter(this.adapterConstructor);
        return server;
    }
};
